import { DeleteGroupDto } from '../../../dto/deletegroup/deletegroupdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface DeleteGroupRequest extends APIRequest
{
    getDeleteGroupRequest(): DeleteGroupDto;
}

export class DeleteGroupRequestImpl extends APIRequestDtoImpl implements DeleteGroupRequest
{
    constructor(private getDeleteGroupData: DeleteGroupDto)
    {
        super();
    }

    getDeleteGroupRequest(): DeleteGroupDto
    {
        return this.getDeleteGroupData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/group/deletegroup/deletegrouprequest.tsx